import { buildQueryString } from '../../commons/grid/buildQueryString.js';

/**
 * Query de la grilla de Tickets.
 *
 * Las 74 claves que viajan al backend, declaradas una vez. Antes eran 73 concatenaciones de
 * string dentro del componente; el contrato exacto está fijado en ticketsGridQuery.test.js,
 * que se escribió ANTES de este refactor justamente para poder hacerlo sin cambiarlo.
 *
 * Fase 2 de VEC-3721.
 */

/** Los filtros: el nombre del param coincide con el del campo. */
const paramsDeFiltro = (filterQuery) => ({
	ticketTipo: filterQuery.ticketTipo,
	entidad: filterQuery.entidad,
	entidades: filterQuery.entidades,
	vin: filterQuery.vin,
	unidad: filterQuery.unidad,
	id: filterQuery.id,
	estado: filterQuery.estado,
	nivelAprobacionPresupuesto: filterQuery.nivelAprobacionPresupuesto,
	fechaHoraAlta: filterQuery.fechaHoraAlta,
	fechaDesde: filterQuery.fechaDesde,
	fechaHasta: filterQuery.fechaHasta,
	fechaEnTaller: filterQuery.fechaEnTaller,
	detalle: filterQuery.detalle,
	servicio: filterQuery.servicio,
	movilPersona: filterQuery.movilPersona,
	gerenciador: filterQuery.gerenciador,
	region: filterQuery.region,
	subRegion: filterQuery.subRegion,
	base: filterQuery.base,
	pais: filterQuery.pais,
	centroCostos: filterQuery.centroCostos,
	centroBeneficios: filterQuery.centroBeneficios,
	responsable1: filterQuery.responsable1,
	enTaller: filterQuery.enTaller,
	mttTotal: filterQuery.mttTotal,
	mttParcial: filterQuery.mttParcial,
	encuestaNivelSatisfaccion: filterQuery.encuestaNivelSatisfaccion,
	fechaRealizado: filterQuery.fechaRealizado,
	fechaHoraTurno: filterQuery.fechaHoraTurno,
	turnoAsignado: filterQuery.turnoAsignado,
	tipoModelo: filterQuery.tipoModelo,
	abono: filterQuery.abono,
	origen: filterQuery.origen,
	turnoInicio: filterQuery.turnoInicio,
	turnoFinal: filterQuery.turnoFinal,
	fechaPrometidaInicio: filterQuery.fechaPrometidaInicio,
	fechaPrometidaFinal: filterQuery.fechaPrometidaFinal,
	fechaPrometidaAsignada: filterQuery.fechaPrometidaAsignada,
	prioridad: filterQuery.prioridad,
	transportadora: filterQuery.transportadora,
	rentadora: filterQuery.rentadora,
	clientExternalTicketId: filterQuery.clientExternalTicketId,
	usuarioCreacion: filterQuery.usuarioCreacion,
});

/**
 * El ordenamiento. Acá está lo que antes quedaba implícito en 30 concatenaciones: el param
 * NO se llama igual que el campo. `ticketTipo` viaja como `tipoTicketSort` y `responsable1`
 * como `responsableSort`, y hay campos del estado que no tienen param (`entidades`,
 * `nivelAprobacionPresupuesto`, `fechaRealizado`): ningún endpoint los acepta, así que su
 * columna no ofrece ordenar (ver VEC-3721).
 */
const paramsDeOrden = (sortQuery) => ({
	idSort: sortQuery.id,
	tipoTicketSort: sortQuery.ticketTipo,
	estadoSort: sortQuery.estado,
	fechaHoraAltaSort: sortQuery.fechaHoraAlta,
	usuarioCreacionSort: sortQuery.usuarioCreacion,
	detalleSort: sortQuery.detalle,
	servicioSort: sortQuery.servicio,
	entidadSort: sortQuery.entidad,
	unidadSort: sortQuery.unidad,
	gerenciadorSort: sortQuery.gerenciador,
	regionSort: sortQuery.region,
	subRegionSort: sortQuery.subRegion,
	baseSort: sortQuery.base,
	paisSort: sortQuery.pais,
	centroCostosSort: sortQuery.centroCostos,
	centroBeneficiosSort: sortQuery.centroBeneficios,
	responsableSort: sortQuery.responsable1,
	enTallerSort: sortQuery.enTaller,
	encuestaNivelSatisfaccionSort: sortQuery.encuestaNivelSatisfaccion,
	fechaHoraTurnoSort: sortQuery.fechaHoraTurno,
	abonoSort: sortQuery.abono,
	tipoModeloSort: sortQuery.tipoModelo,
	mttTotalSort: sortQuery.mttTotal,
	mttParcialSort: sortQuery.mttParcial,
	tiempoEnTallerSort: sortQuery.tiempoEnTaller,
	fechaPrometidaSort: sortQuery.fechaPrometida,
	prioridadSort: sortQuery.prioridad,
	transportadoraSort: sortQuery.transportadora,
	rentadoraSort: sortQuery.rentadora,
	clientExternalTicketIdSort: sortQuery.clientExternalTicketId,
});

export const buildTicketsQuery = (pagination, filterQuery, sortQuery) =>
	buildQueryString(Object.assign(
		{ page: pagination.page, perPage: pagination.perPage },
		paramsDeFiltro(filterQuery),
		paramsDeOrden(sortQuery)
	));
